import { render, staticRenderFns } from "./ExpressTracking.vue?vue&type=template&id=bdc19554&scoped=true&"
import script from "./ExpressTracking.vue?vue&type=script&lang=js&"
export * from "./ExpressTracking.vue?vue&type=script&lang=js&"
import style0 from "./ExpressTracking.vue?vue&type=style&index=0&id=bdc19554&lang=scss&scoped=true&"
import style1 from "./ExpressTracking.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ExpressTracking.vue?vue&type=style&index=2&id=bdc19554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc19554",
  null
  
)

export default component.exports